import React from 'react'
import Header from 'newComponents/Layout/Header'
import Footer from 'newComponents/Layout/Footer'
import { useIsMobile } from 'newHooks/useIsMobile';
import Styles from '../styles.module.sass'

function GuestLayout({ children }) {
  const { isMobile } = useIsMobile()

  return (
    <>
      <Header type="complete" />
        <main className={Styles?.contentGuestLayout}>{children}</main>
      <Footer type={isMobile === 'desktop' ? "complete" : null} />
    </>
  );
}

export default GuestLayout;